exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center}.modal-content{background-color:#fff;border-radius:5px}.modal button{background:#ec7211;color:#fff;border:none;border-color:#ec7211;border-radius:3px;padding:5px;margin-top:10px}.modal p{padding:5px}.modal h2{padding:7px 5px}", ""]);

// exports
